import styled from "styled-components";
import bg1 from "./assets/Graphics/bg1.png";
import bg2 from "./assets/Graphics/bg2.png";
import bg3 from "./assets/Graphics/bg3.png";
import bg4 from "./assets/Graphics/bg4.png";
import bg6 from "./assets/Graphics/bg6.png";
import bg8 from "./assets/Graphics/bg8.png";

export const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;

  /* background-color: red; */
`;

export const SingleCard = styled.div`
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: #f5f4f1;
  border: 0.1px solid #38041d;
  border-radius: 20px;
  width: auto;
  /* height: 300px; */
  margin: 40em 0;
  position: relative;

  h3 {
    position: absolute;
    width: 270px;
    height: 80px;
    color: #38041d;
    top: -50px;
    left: 40px;
    /* overflow: hidden; */

    border: 0.1px solid #38041d;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(10px);

    /* background-image: url(${bg1});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center; */

    /* filter: blur(0.7px); */
    /* &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1; 
    } */

    /* Text styling */
    p {
      font-family: Georgia;
      font-size: 18px;
      font-weight: 100;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      text-align: center;
      transform: translate(-50%, -50%);
      z-index: 2; /* Ensure text is on top of the blurred background */
    }
  }
  @media (max-width: 768px) {
  }
`;

export const Content = styled.div`
  /* display: flex; */
  /* flex-direction: column; */
  /* flex: 1 1 auto; */
  /* text-align: end; */
  /* background-color: #38041d; */
  /* position: relative; */

  width: 320px;
  height: 240px;
  right: -10px;
  border-left: 1px dashed #9c9c9c;
  /* padding: 10px 30px; */

  /* font-weight: 900; */
  position: absolute;
  /* width: auto; */
  background-image: url(${bg8});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  /* background-color: red; */
  border-left: 1px dashed #686868;
  /* border-radius: 8px; */
  /* backdrop-filter: blur(4px); */
  display: flex;
  flex-direction: row;
  align-items: center;

  ul {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    /* margin-top: 1rem; */
    /* padding-left: 0; */
    /* background-color: #f9f9f9; */
    /* padding: 1rem 0; */
  }

  li {
    /* font-size: clamp(14px, 1vw, 3em); */
    margin: 3px;
    /* padding: 0.5rem 0; */
    display: flex;
    align-items: center;
    /* font-size: 1.1rem; */
  }

  li span {
    /* margin-left: 10px; */
    color: #333;
    font-weight: bold;
  }

  p {
  }

  @media (max-width: 576px) {
    /* order: 1; */
  }
`;

export const IconContainer = styled.div`
  flex: 1 1 auto;
  display: flex;
  position: relative;

  /* background-color: green; */
  img {
    transform: translateY(10px);
    opacity: 0;
    transition: opacity 0.5s ease, transform 0.5s ease;
    border-right: 0.1px dashed #38041d;
    padding: 25px;
    width: 10em;
    height: auto;

    &.visible {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Description = styled.p`
  align-self: center;
  padding: 10px;

  /* width: 10%; */

  ul {
    list-style: none;
    /* margin-top: 1rem; */
    padding-left: 10px;
  }

  li {
    padding: 0.4rem 0;
    display: flex;
    align-items: center;
    text-align: start;
    text-transform: capitalize;
    /* font-size: 1.1rem; */
    span {
      font-size: clamp(14px, 1.1vw, 3em);
      font-weight: 900;
    }
    svg {
      /* background-color: green; */
    }
  }

  li span {
    /* margin-left: 10px; */
    align-self: center;
    color: #333;
    font-weight: bold;
  }
`;

export const Title = styled.h2`
  /* flex: 0 1 auto; */

  font-size: 24px;
  text-align: center;
  /* color: #1f3d2b; */
  /* margin: 0; */
  font-weight: bold;
  .subtitle {
    font-weight: normal;
    /* font-style: italic; */
    font-size: 18px;
  }
`;
